import { render } from "./VolunteerInlineAuth.vue?vue&type=template&id=0df99982&scoped=true"
import script from "./VolunteerInlineAuth.vue?vue&type=script&lang=js"
export * from "./VolunteerInlineAuth.vue?vue&type=script&lang=js"

import "./VolunteerInlineAuth.vue?vue&type=style&index=0&id=0df99982&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0df99982"]])

export default __exports__